import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import users from "../../data/users";
import env from '../../config';
import axios from 'axios';

const ExtraServiceList = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const user = users.find((u) => u.id === parseInt(userId));
  const navigate = useNavigate();
  const location = useLocation();
  const [projects, setProjects] = useState([]);
  let stylesLoaded = false;
  const backendUrl = env.backendUrl;
  const frontendUrl = env.frontendUrl;
  const url = backendUrl;
  const [selectedImage, setSelectedImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setIsUploading(true); // começa o loading

    const isTailwindRoute = location.pathname.startsWith('/extraService-list');
    if (isTailwindRoute && !stylesLoaded) {
      import('../../tailwind.css')
        .then(() => {
          stylesLoaded = true;
          setIsUploading(false);
        })
        .catch(error => {
          console.error('Erro ao carregar estilos do Timesheet:', error);
        });
    }
  }, [location]);

  useEffect(() => {
    localStorage.setItem('userId', userId);

    if (userId === '0') {
      fetch(url + '/extra-services')
        .then((res) => res.json())
        .then(data => {
          const sortedData = data.data.sort((a, b) => {
            return new Date(b.request_date) - new Date(a.request_date);
          });
          setProjects(sortedData);
        })
        .catch((err) => console.error('Erro ao buscar projetos:', err));
    } else {
      fetch(url + '/extra-services/findByUserId/' + userId)
        .then((res) => res.json())
        .then(data => {
          // console.info(data);
          setProjects(data);
        })
        .catch((err) => console.error('Erro ao buscar projetos:', err));
    }


  }, []);

  const handleEditService = (projectId) => {
    navigate(`/extraService-edit?id=${projectId}`);
  };

  const handleProjectClick = (projectId) => {
    navigate(`/extraService-details?id=${projectId}`);
  };

  const handlePhotoUpload = (e, service_id) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map((file) => file);

    const formData = new FormData();
    formData.append('file', newPhotos[0]);

    setIsUploading(true); // começa o loading
    axios.post(url + `/api/upload-image?subfolder=extra-services`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        const imagePath = response.data.path;
        setIsUploading(false);

        // Atualizar o projeto correto
        setProjects(prevProjects => prevProjects.map(proj => {
          if (proj.id === service_id) {
            const updatedPhotos = [
              ...(proj.reference_photos ? JSON.parse(proj.reference_photos) : []),
              imagePath
            ];
            // Atualiza o servidor
            axios.put(url + `/extra-services/${service_id}`, {
              reference_photos: updatedPhotos,
            });
            return { ...proj, reference_photos: JSON.stringify(updatedPhotos) };
          }
          return proj;
        }));
      })
      .catch((error) => {
        console.error(error);
        setIsUploading(false);
      });
  };


  const handleRemovePhoto = (index, service_id) => {
    const confirmDelete = window.confirm('Are you sure?');
    if (!confirmDelete) return;

    setProjects(prevProjects => prevProjects.map(proj => {
      if (proj.id === service_id) {
        const currentPhotos = proj.reference_photos ? JSON.parse(proj.reference_photos) : [];
        const updatedPhotos = currentPhotos.filter((_, i) => i !== index);

        axios.put(url + `/extra-services/${service_id}`, {
          reference_photos: updatedPhotos,
        });

        return { ...proj, reference_photos: JSON.stringify(updatedPhotos) };
      }
      return proj;
    }));
  };

  const handleDeleteService = (serviceId) => {
    const confirmDelete = window.confirm('Are you sure?');
    if (!confirmDelete) return;

    axios.delete(`${url}/extra-services/${serviceId}`)
      .then(() => {
        setProjects(prevProjects => prevProjects.filter(project => project.id !== serviceId));
      })
      .catch(error => {
        console.error('Erro ao excluir serviço:', error);
        alert('Erro ao excluir serviço.');
      });
  };

  const handleCopyToClipboard = (service) => {
    // const photos = JSON.parse(service.reference_photos || '[]');
    // const imageUrl = photos.length ? `${url}/storage/${photos[0]}` : '';
    //   const message = `📍 *Address:* ${service.service_address}
    // 📦 *Status:* ${service.request_status.replace('_', ' ')}
    // 💰 *Billing:* ${service.billing_status.replace('_', ' ')}

    // ${imageUrl ? `🖼 Image: ${imageUrl}` : ''}`;

    // const whatsappLink = `https://wa.me/15551234567?text=${encodeURIComponent(message)}`;

    // Abre o link do WhatsApp em uma nova aba
    // window.open(whatsappLink, '_blank');

    sendWhatsappMessage(service);
  };

  const sendWhatsappMessage = async (service) => {
    // DEV
    // const token = 'EAAXUZCZBrp4SEBOyyfluC8rksZCASsJAXWasWuDDQyfhZCD3ud4pLUfdjnhZAn31G8wSQKJUc7DxZAVMOzkZAZC4ZBhlMaHUgqZC6Jk9PavZAv93XAGxfFLwrE4h13yVtoFZCOY1KaKPiJusVi4tCwCUb9AcPAAWBeQJo1yDrGagEn6IQJ6MYbFPOYRKEk0dAcZCOCa42jIJskvmsTti2DPrwj7vZB7vny';

    //willias
    const token = 'EAAXUZCZBrp4SEBOxSQtIQE7PYxb9MZCS9OUWzQnwKT9dsEZC6ksXn077yfUFd66uSIH2t6YBZAcuuOHsjRauRdruvbn6QBRKBrE1qjjdFlpzsjUwR5SgON1l5Lm1oEh6ZChPlM2un3UfPMMYbZA1qiPoaYvf8yewtZAQkbs7cPmQYU4CXDQavIX32R2HZACSWyNhiYCKLFaInwe7DseJUGXDhQf6Pkv2sb3kZCKHaWNUnm';

    //temp
    //const token = 'EAAXUZCZBrp4SEBO6of0BZBYZBSDZAb6bNPBGe1QkkWLdjdtztGGIzK8VWT49RZCZBUuDb2pbDUN0USabqA4PwNkcXYkH5iyC4SnjRfUfxhzWhWnN1MAgqOLZB9TbOI8M0bKQreokMfp1gNS8vrUZC486ZCDVrBmI1zZBSA6pAtkFnTO8Q2ltQlvkzxHo6XxpMVrdyWurKyZCosQxb0shYdNTeTyFLFXC';
    const phoneNumberId = '692113570644650';
    const url = `https://graph.facebook.com/v22.0/${phoneNumberId}/messages`;
    const worker_name = users.find((u) => u.id === parseInt(service.assigned_employee)).name;
    const lines = [
      `Hello, *${worker_name}*! 👋`,
      ``,
      `New service request received!`,
      ``,
      `*Location:* ${service.service_address}`,
      `*Date:* ${service.request_date}`,
      `*Request:* ${service.service_description}`,
      ``,
      ``,
      `*Details:*`,
      `${frontendUrl}/extraService-details?id=${service.id}`
    ];

    const body = {
      messaging_product: 'whatsapp',
      to: '14084693124',
      type: 'text',
      text: {
        preview_url: true,
        body: lines.join('\n')
      }
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      const data = await response.json();
      console.log('Resposta:', data);
      alert("Message sent successfully!");
    } catch (error) {
      console.error('Erro ao enviar mensagem:', error);
    }
  };



  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Services</h2>
      <h2 className="text-2xl font-bold mb-4">
        Worker: {user?.name}
      </h2>
      <div className="space-y-3">

        {user?.id === 0 && (
          <button
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mb-4"
            onClick={() => navigate('/extraService-new')}
          >
            + New Service
          </button>
        )}

        {projects.map((project) => (
          <div key={project.id} className="p-4 bg-white shadow rounded-2xl">
            <h1 className="mb-4">
              <span
                className="inline-block py-2 font-medium"
              >
                {project.request_date}
              </span>
              <hr />
            </h1>

            <div className="flex flex-wrap items-center gap-2 mb-2">
              <span className={`px-3 py-1 rounded-full text-sm font-semibold 
                ${project.request_status === 'pending' ? 'bg-red-200 text-red-800' : ''}
                ${project.request_status === 'completed' ? 'bg-green-200 text-green-800' : ''}
                ${project.request_status === 'forwarded' ? 'bg-blue-200 text-blue-800' : ''}
                ${project.request_status === 'ignored' ? 'bg-gray-300 text-gray-800' : ''}
              `}>
                <span className="font-semibold block text-blue-800">Request:</span>
                {project.request_status.replace('_', ' ').toUpperCase()}
              </span>
              <span className={`px-3 py-1 rounded-full text-sm font-semibold ml-2 max-w-[140px] whitespace-nowrap text-center
                ${project.billing_status === 'waiting' ? 'bg-orange-200 text-orange-800' : ''}
                ${project.billing_status === 'to_invoice' ? 'bg-red-200 text-red-800' : ''}
                ${project.billing_status === 'invoiced' ? 'bg-green-200 text-green-800' : ''}
                ${project.billing_status === 'no_invoice_needed' ? 'bg-gray-300 text-gray-800' : ''}
              `}>
                <span className="font-semibold block text-blue-800">Billing: {project.service_price ? '$' + project.service_price : '' }</span>
                {project.billing_status.replace(/_/g, ' ').toUpperCase()}
              </span>
              <span className={`px-3 py-1 rounded-full text-sm font-semibold ml-2
                ${project.evidence_status === 'send' ? 'bg-red-200 text-red-800' : ''}
                ${project.evidence_status === 'sent' ? 'bg-green-200 text-green-800' : ''}
                ${project.evidence_status === 'ignored' ? 'bg-gray-300 text-gray-800' : ''}
                ${project.evidence_status === 'pending' ? 'bg-red-200 text-red-800' : ''}
              `}>
                <span className="font-semibold block text-blue-800">Evidence:</span>
                {project.evidence_status.replace(/_/g, ' ').toUpperCase()}
              </span>

            </div>

            <div className="items-start">
              <div>
                <p className="text-lg mb-4">{project.service_address}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              {user?.id === 0 && (
                <label className="flex flex-col items-center justify-center w-20 h-20 border border-dashed border-gray-400 rounded-lg cursor-pointer text-center text-xs text-gray-500">
                  +<br />Add Photo
                  <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => handlePhotoUpload(e, project.id)} />
                </label>
              )}
              {JSON.parse(project.reference_photos || '[]').map((src, index) => (
                <div key={index} className="relative w-20 h-20">
                  <img src={url + '/storage/' + src}
                    onClick={() => setSelectedImage(src)}
                    alt={`Uploaded ${index + 1}`} className="w-full h-full object-cover rounded-lg" />
                  {user?.id === 0 && (
                    <button
                      className="absolute -top-2 -right-2 bg-white border border-gray-300 rounded-full w-5 h-5 text-xs text-black shadow"
                      onClick={() => handleRemovePhoto(index, project.id)}
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="flex justify-end gap-2 mt-2">
              <button
                onClick={() => handleCopyToClipboard(project)}
                className="bg-gray-500 text-white rounded-full w-12 h-12 flex items-center justify-center hover:bg-gray-700"
                title="Copiar para WhatsApp"
              >
                📋
              </button>
              <button
                onClick={() => handleProjectClick(project.id)}
                className="bg-blue-500 text-white rounded-full w-12 h-12 items-center justify-center flex hover:bg-blue-700"
              >
                i
              </button>
              {user?.id === 0 && (
                <button
                  onClick={() => handleEditService(project.id)}
                  className="bg-green-500 text-white rounded-full w-12 h-12 flex items-center justify-center hover:bg-green-700"
                  title="Edit"
                >
                  ✏️
                </button>
              )}
              {user?.id === 0 && (
                <button
                  onClick={() => handleDeleteService(project.id)}
                  className="bg-red-500 text-white rounded-full w-12 h-12 flex items-center justify-center hover:bg-red-700"
                  title="Delete"
                >
                  ×
                </button>
              )}
            </div>

          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative">
            {/* Botão de fechar */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-4 -right-4 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow-lg hover:bg-gray-200"
              aria-label="Fechar"
            >
              ✕
            </button>

            {/* Imagem ampliada */}
            <img
              src={url + '/storage/' + selectedImage}
              alt="Zoomed"
              className="max-w-[90vw] max-h-[90vh] rounded-lg border-4 border-white shadow-xl"
            />
          </div>
        </div>
      )}

      {isUploading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-500 border-t-transparent"></div>
            <p className="text-white mt-4 text-lg font-semibold">Uploading...</p>
          </div>
        </div>
      )}

    </div>
  );
};

export default ExtraServiceList;
